import React from "react";
import { Link } from "react-router-dom";
import { Button, Panel } from "../ui";
import Avatar from "./Avatar";
import { HEADER, PROMISE_LINE, initials } from "./threadFormat";

export default function RosterCard({ advisors }) {
  return (
    <aside
      data-slot="thread-side"
      className="tw-mb-4"
      aria-labelledby="thread-side-heading"
    >
      <Panel as="div" className="tw-p-4">
        {/* A real heading (fix round 1, finding 6): demoting this to a <div>
            traded away the side column's accessible name and dropped it out
            of heading navigation, to satisfy an imprecise test query rather
            than fix a markup problem. The <h2>/<h3> collision is a query
            problem — scope ThreadHeader's query with `{ level: 2 }` instead.
            `aria-labelledby` on the <aside> also gives the landmark itself a
            name, which the ThreadHeader-only version couldn't. */}
        <h3
          id="thread-side-heading"
          className="tw-m-0 tw-mb-3 tw-text-sm tw-font-bold tw-text-text"
        >
          {HEADER}
        </h3>
        <div className="tw-flex tw-flex-wrap tw-gap-x-6 tw-gap-y-3">
          {advisors.map((a) => (
            <div key={a._id} className="tw-flex tw-items-center tw-gap-3">
              <Avatar initials={initials(a)} role="advisor" />
              <div className="tw-text-sm">
                <div className="tw-font-semibold tw-text-text">
                  {a.firstName} {a.lastName}
                </div>
                <div className="tw-text-xs tw-text-text-muted">
                  {a.title || "Astra advisor"}
                </div>
              </div>
            </div>
          ))}
        </div>
        <p className="tw-mb-0 tw-mt-3 tw-text-xs tw-text-text-muted">
          {PROMISE_LINE}
        </p>
        <Button
          as={Link}
          variant="quiet"
          size="sm"
          className="tw-mt-3"
          to="/dashboard"
          state={{ actionType: "VIDEO_CALL" }}
        >
          Book a meeting
        </Button>
      </Panel>
    </aside>
  );
}
